export default "__VITE_ASSET__TSqRvhRZ__"